import {
    Directive,
    ElementRef,
    Input,
    OnChanges,
    SimpleChanges,
} from "@angular/core";

@Directive({
    selector: "[hVtoScrollIntoView]",
})
export class VtoScrollDirective implements OnChanges {
    @Input() public vtoScrollIntoView = false;

    constructor(public elementReference: ElementRef) {}

    public ngOnChanges(changes: SimpleChanges) {
        if (
            changes.vtoScrollIntoView &&
            changes.vtoScrollIntoView.currentValue
        ) {
            window.requestAnimationFrame(() => {
                this.elementReference.nativeElement.scrollIntoView({
                    behavior: "smooth",
                    block: "nearest",
                    inline: "center",
                });
            });
        }
    }
}
